const ArrowUpIcons = () => {
	return (
		<svg
        className="mx-2"
			width="16"
			height="16"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M6.20711 10.7071C5.81658 11.0976 5.18342 11.0976 4.79289 10.7071C4.40237 10.3166 4.40237 9.68339 4.79289 9.29286L10.5858 3.49997C11.3668 2.71892 12.6332 2.71892 13.4142 3.49997L19.2071 9.29286C19.5976 9.68339 19.5976 10.3166 19.2071 10.7071C18.8166 11.0976 18.1834 11.0976 17.7929 10.7071L13 5.91419V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V5.91418L6.20711 10.7071Z"
				fill="#33383F"
			/>
		</svg>
	);
};
export default ArrowUpIcons;
